import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react/components/Modal';
import { Button } from 'onefaceui-react-components';

import { resourceFrom } from 'react/containers/pages/TicketDetails/ticketDetailsUtils';
import resources from 'react/containers/pages/TicketDetails/ticketDetailsResources';

function CommentsAddModal(props) {
  const {
    modalIsOpen,
    setModalIsOpen,
    handlePersistCommentAction,
    data,
    tab: { key: screenKey },
    commentToEdit,
    setCommentToEdit
  } = props;

  const [textarea, setTextarea] = useState('');

  const closeModal = () => {
    setTextarea('');
    setModalIsOpen(false);
    setCommentToEdit(null);
  };

  const saveComment = useCallback(() => {
    const ticketId = data?.get('id');
    if (ticketId && screenKey && !commentToEdit) {
      handlePersistCommentAction({ textarea, ticketId, screenKey });
    } else if (ticketId && screenKey && commentToEdit) {
      handlePersistCommentAction({
        textarea, ticketId, screenKey, commentToEdit
      });
    } else {
      throw new Error('Error trying to save a new comment!');
    }

    closeModal();
  }, [data, screenKey, commentToEdit, textarea]);

  const valueToTextarea = commentToEdit?.get
    ? commentToEdit.get('note')
    : '';

  useEffect(() => {
    if (commentToEdit) {
      setTextarea(valueToTextarea);
    }
  }, [commentToEdit]);

  return (
    <Modal
      className="commentsSection__addCommentModal"
      isOpen={modalIsOpen}
      title={resourceFrom(resources.commentModal.newTitle)}
      closeModalFn={closeModal}
    >
      <div className="addCommentModal__content">
        <div className="addCommentModal__textarea">
          <textarea value={textarea} onChange={(e) => setTextarea(e.target.value)} />
        </div>
        <div className="addCommentModal__buttons">
          <Button type="secondary" className="addItem" onClick={closeModal}>
            {resourceFrom(resources.commentModal.cancelButton)}
          </Button>
          <Button type="primary" className="addItem" onClick={saveComment}>
            {resourceFrom(resources.commentModal.saveButton)}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

CommentsAddModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  setModalIsOpen: PropTypes.func.isRequired,
  handlePersistCommentAction: PropTypes.func.isRequired,
  data: PropTypes.object,
  tab: PropTypes.shape({
    key: PropTypes.string.isRequired
  }),
  commentToEdit: PropTypes.object,
  setCommentToEdit: PropTypes.func.isRequired
};

CommentsAddModal.defaultProps = {
  tab: {},
  data: {},
  commentToEdit: null
};

export default CommentsAddModal;
